import { ContextTokenType } from '@atlassian/help-center-common-component/forge-ui/types';

export const ENDPOINT_MAP = {
    [ContextTokenType.JIRA]: '/rest/internal/2/forge/context/token',
    [ContextTokenType.JSM]: '/rest/servicedesk/1/customer/servicedesk-data/forge/context-token',
};

export const getForgeContextTokenEndpoint = (contextTokenType: keyof typeof ENDPOINT_MAP) =>
    ENDPOINT_MAP[contextTokenType] || ENDPOINT_MAP[ContextTokenType.JSM];
